module.exports = __webpack_public_path__ + "static/media/image_part_006.24f32c89.jpg";